function getCsrfToken(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith("csrftoken="));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
}

export async function setBackendLanguage(locale: string): Promise<void> {
  if (typeof window === "undefined") return;

  // const { public: config } = useRuntimeConfig();
  // const baseUrl = config.apiUrl.replace(/\/api\/?$/, "");
  const url = `/api/i18n/set_language/`;

  const csrfToken = getCsrfToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/x-www-form-urlencoded",
  };
  if (csrfToken) {
    headers["X-CSRFToken"] = csrfToken;
  }

  const body = new URLSearchParams({ language: locale, next: "/" });

  await window
    .fetch(url, {
      method: "POST",
      headers,
      body: body.toString(),
      credentials: "include",
      redirect: "manual",
    })
    .catch((err) => {
      console.warn("[i18n] set_language failed:", err);
    });
}
